import type { ContextCheck, ContextInjection, ToolContext, ToolResult } from "./tools";

const normalize = (value: string) => value.trim().toLowerCase();

const namedDepartment = (args: Record<string, unknown>): unknown => {
  const direct = args["homeDepartment"];
  if (direct !== undefined) return direct;
  const nested = args["createProjectRequest"];
  return nested && typeof nested === "object" ? (nested as Record<string, unknown>)["homeDepartment"] : undefined;
};

const projectDepartmentId = (ctx: ToolContext, name: unknown): string | undefined => {
  const departments = ctx.auth.projectDepartments ?? [];
  if (typeof name === "string" && name.trim()) {
    return departments.find((d) => normalize(d.name) === normalize(name))?.id;
  }
  return ctx.auth.defaultProjectDepartmentId;
};

const refuse = (deviationCode: string, message: string): ToolResult => ({ ok: false, deviationCode, message });

export const projectContextChecks: Record<string, ContextCheck> = {
  createProject: (args, ctx) => {
    const departments = ctx.auth.projectDepartments ?? [];
    if (departments.length === 0 || projectDepartmentId(ctx, namedDepartment(args))) return null;
    const named = namedDepartment(args);
    const names = departments.map((d) => d.name).join(", ");
    return refuse(
      "UNKNOWN_DEPARTMENT",
      typeof named === "string" && named.trim()
        ? `Fant ingen avdeling som heter «${named}» du kan opprette prosjekter i. Velg blant: ${names}.`
        : `Spør brukeren hvilken avdeling prosjektet skal ligge under. Velg blant: ${names}.`,
    );
  },
};

export const projectContextInjections: Record<string, ContextInjection> = {
  createProject: {
    bodyKey: "createProjectRequest",
    bodyDefaults: { homeDepartmentId: (ctx, args) => projectDepartmentId(ctx, namedDepartment(args)) },
    excludeFromBody: ["homeDepartment"],
  },
};
